import { render, staticRenderFns } from "./CrmEditMessageEvent.vue?vue&type=template&id=70d60ff7"
import script from "./CrmEditMessageEvent.vue?vue&type=script&lang=ts"
export * from "./CrmEditMessageEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d60ff7')) {
      api.createRecord('70d60ff7', component.options)
    } else {
      api.reload('70d60ff7', component.options)
    }
    module.hot.accept("./CrmEditMessageEvent.vue?vue&type=template&id=70d60ff7", function () {
      api.rerender('70d60ff7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/edit/CrmEditMessageEvent.vue"
export default component.exports